export * from './types.js';
export * from './events.js';
export * from './countries.js';
export * from './schedule.js';
export * from './royale.js';
export * from './bracket.js';
export * from './elo.js';
export * from './rng.js';
export * from './format.js';

/** Bumped whenever the wire format changes; the client refuses mismatches. */
export const PROTOCOL_VERSION = 1;

export const APP_NAME = 'FLAG BATTLE WORLD LIVE';
